import Vue from 'vue';
import VueRouter from 'vue-router';
import routes from './routes.js';
import store from '@/store';

VueRouter.prototype.open = function(routeObject) {
	const { href } = this.resolve(routeObject);
	window.open(href, '_blank');
};

Vue.use(VueRouter);

const router = new VueRouter({
	mode: 'hash',
	base: process.env.BASE_URL,
	linkActiveClass: 'is-active',
	routes
});

router.beforeResolve((to, from, next) => {
	if (to.name === from.name) {
		return;
	}

	const noneAuthRequiredRoutes = ['Login', 'RecoverPassword', 'ResetPassword'];
	const isUserAuthenticated = store.getters['user/isLoggedIn'];

	if (noneAuthRequiredRoutes.includes(to.name) || isUserAuthenticated) {
		next();

		return;
	}

	store.dispatch('user/logout', null, { root: true });

	next('/login');
});

export default router;
